module.exports = __webpack_public_path__ + "images/3c8c2ef9b91d225cf84f207bc2ba83f68.svg";